import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsUnblindingReasonServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingReasonServices";

const UpdateStudyUnblindingReason = ({
  reasonData,
  getEIWRSUnblindingReasonData,
  Show,
  Hide,
  Title,
  setReasonId,
}) => {
  const { studyId } = useParams()
  const [reason, setReason] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateEIWRSUnblindingReasonData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Unblinding Reason!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = reasonData?._id;
        userData.studyId = studyId;
        userData.reason = reason;
        let data = await eiwrsUnblindingReasonServices.updateEIWRSUnblindingReasonData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSUnblindingReasonData();
          Hide();
          setReasonId("");
          setReason("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setReason(reasonData?.reason);
  }, [reasonData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Reason{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setReason(e.target.value)}
              value={reason}
              className="br3"
              placeholder="Enter Reason"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!reason || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSUnblindingReasonData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update Reason"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyUnblindingReason;
